// Cache to avoid refetching same icons repeatedly
const base64Cache = new Map();

export async function fetchAsBase64(url) {
  if (!url) return null;

  // ✅ Check cache first
  if (base64Cache.has(url)) {
    return base64Cache.get(url);
  }

  try {
    // ✅ Fetch image as blob (supports local & remote CORS-safe URLs)
    const response = await fetch(url, { mode: "cors" });
    if (!response.ok)
      throw new Error(`Failed to load image: ${response.status}`);
    const blob = await response.blob();

    // ✅ Convert blob to Base64 string
    const base64 = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = () => reject(new Error("FileReader error"));
      reader.readAsDataURL(blob);
    });

    // ✅ Store in cache
    base64Cache.set(url, base64);
    return base64;
  } catch (err) {
    console.warn("⚠️ fetchAsBase64 error for URL:", url, err);
    return null;
  }
}

export const loadImageAsBase64 = async (url) => {
  if (base64Cache.has(url)) return base64Cache.get(url);
  const base64 = await fetchAsBase64(url);
  base64Cache.set(url, base64);
  return base64;
};

export const chunkArray = (arr = [], size = 1) => {
  if (!Array.isArray(arr) || size <= 0) return [];
  return Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
    arr.slice(i * size, i * size + size),
  );
};
